import { render, staticRenderFns } from "./product_npbkcd2.vue?vue&type=template&id=2a2c413f&scoped=true"
import script from "./product_npbkcd2.vue?vue&type=script&lang=js"
export * from "./product_npbkcd2.vue?vue&type=script&lang=js"
import style0 from "./product_npbkcd2.vue?vue&type=style&index=0&id=2a2c413f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2c413f",
  null
  
)

export default component.exports